import React, { FC } from 'react';

import { GrafanaTheme2 } from '@grafana/data';
import { Icon, Spinner, useStyles2 } from '@grafana/ui';

import { css } from '@emotion/css';

import { AnalysisDisplayStatus } from 'types';

interface AnalysisIconProps {
  displayStatus: AnalysisDisplayStatus;
}

const AnalysisIcon: FC<AnalysisIconProps> = ({ displayStatus }) => {
  const styles = useStyles2(getStyles);

  switch (displayStatus) {
    case 'interesting':
      return <Icon className={styles.interesting} name="info-circle" size="lg" />;
    case 'passed':
      return <Icon className={styles.success} name="check-circle" size="lg" />;
    case 'failed':
      return <Icon className={styles.failure} name="minus-circle" size="lg" />;
    case 'running':
      return <Spinner className={styles.loading} size="lg" />;
    case 'skipped':
      return <Icon className={styles.skipped} name="circle" size="lg" />;
    default:
      return <Icon className={styles.loading} name="question-circle" size="lg" />;
  }
};

// Define CSS Styles
const getStyles = (theme: GrafanaTheme2) => {
  return {
    loading: css`
      color: rgb(50, 116, 217);
    `,
    skipped: css`
      color: ${theme.colors.text.maxContrast};
    `,
    success: css`
      color: rgb(86, 166, 75);
    `,
    interesting: css`
      color: rgb(255, 120, 10);
    `,
    failure: css`
      color: rgb(224, 47, 68);
    `,
  };
};

export default AnalysisIcon;
